import {UrlSegment, UrlSegmentGroup} from "@angular/router";

const supportedLanguages = ['ro', 'en', 'ua'];
const defaultLanguage = 'ro';

export function languageMatcher(segments: UrlSegment[]) {

  const language: string = localStorage.getItem('language')?.toLocaleLowerCase() || "";
  const isSupportedLang = supportedLanguages.includes(language);
  const firstSegmentLang = segments.length > 0 && supportedLanguages.includes(segments[0].path);

  if (isSupportedLang) {

    if (firstSegmentLang) {
      segments[0].path = language;
    }
    else {

      segments.unshift(new UrlSegment(language, {}));
    }
  }

  else if (segments.length === 0 || !firstSegmentLang) {
    segments.unshift(new UrlSegment(defaultLanguage, {}));
  }
  return { consumed: segments.slice(0, 1) };
}
